import React from "react";
import { cn } from "./cn";

export function EmptyState({ icon, title, description, action, className }) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center py-16 px-6",
        className
      )}
    >
      {icon && (
        <div className="h-14 w-14 rounded-2xl bg-bg-elevated border border-border flex items-center justify-center text-ink-muted mb-4">
          {icon}
        </div>
      )}
      {title && <h3 className="text-base font-semibold text-ink">{title}</h3>}
      {description && (
        <p className="text-sm text-ink-muted mt-1 max-w-md">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Spinner({ size = 16, className }) {
  return (
    <svg
      className={cn("animate-spin", className)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.25" strokeWidth="3" />
      <path d="M22 12a10 10 0 0 1-10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

export function LoadingOverlay({ label = "Loading…" }) {
  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center bg-bg/40 backdrop-blur-sm rounded-xl">
      <div className="flex items-center gap-2 text-ink-muted text-sm">
        <Spinner size={16} />
        <span>{label}</span>
      </div>
    </div>
  );
}

export function SkeletonRow({ cols = 5, className }) {
  return (
    <div className={cn("grid gap-3 py-3", className)} style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
      {Array.from({ length: cols }).map((_, i) => (
        <div key={i} className="h-4 rounded skeleton" />
      ))}
    </div>
  );
}
